export const dataLocal: any = {
    jp: {
        data1: [
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1723630078842/D3P%E5%8D%95%E6%9C%BA%E5%9C%BA%E6%99%AF.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1723616870274/D3P%E5%8D%95%E6%9C%BA%E5%9C%BA%E6%99%AF.jpg',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1727258896860/A3.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1724033112399/D3P%E5%8D%95%E6%9C%BA%E5%9C%BA%E6%99%AF%E5%AF%B9%E6%AF%94%E5%9B%BE.jpg',
                    },
                ],
                info: {
                    name: 'DELTA 3 Plus',
                    desc: '1,024Wh 容量 | 1,500W 出力 (サージ3,000W)\n1,400W AC入力 | 10ミリ秒未満のUPS\n5年間の保証付き',
                    // discountPrice: 111750,
                    // originalPrice: 149000,
                    // pointRate: 5,
                    productId: '8095160795297',
                    variantId: '44597213003937',
                    showBtnMore: false,
                    tips: ['※DELTA 3 Plusの納品遅延について 現在、生産が遅れております。', '■納期状況：11月中旬~11下旬より、順次発送いたします。'],
                },
            },
        ],
        data2: [
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1723616507532/220W%E5%A4%AA%E9%98%B3%E8%83%BD%E5%85%85%E7%94%B5%E5%9C%BA%E6%99%AF.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1723616870273/220W%E5%A4%AA%E9%98%B3%E8%83%BD%E5%85%85%E7%94%B5%E5%9C%BA%E6%99%AF.jpg',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1724033112069/%E8%BD%A6%E5%85%85%E5%9C%BA%E6%99%AF%E5%AF%B9%E6%AF%94%E5%9B%BE%20(2).jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1724033111815/220W%E5%A4%AA%E9%98%B3%E8%83%BD%E5%85%85%E7%94%B5%E5%AF%B9%E6%AF%94%E5%9B%BE.jpg',
                    },
                ],
                info: {
                    name: 'DELTA 3 Plus+220W片面ソーラーパネル',
                    desc: '1,024Wh 容量 | 1,500W 出力 (サージ3,000W)\n1,500W AC入力 & 1,000Wソーラー入力\n10ミリ秒未満のUPS',
                    // discountPrice: 152810,
                    // originalPrice: 218300,
                    // pointRate: 5,
                    productId: '8095169249441',
                    variantId: '44498880888993',
                    showBtnMore: false,
                },
                direction: 'rtl',
            },
            {
                items: [
                    {
                        img: '',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1723616507531/%E8%BD%A6%E5%85%85%E5%9C%BA%E6%99%AF.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1723616870294/%E8%BD%A6%E5%85%85%E5%9C%BA%E6%99%AF.jpg',
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1724033112210/D3P%E5%8D%95%E6%9C%BA%E5%9C%BA%E6%99%AF.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1724033112399/D3P%E5%8D%95%E6%9C%BA%E5%9C%BA%E6%99%AF%E5%AF%B9%E6%AF%94%E5%9B%BE.jpg',
                    },
                ],
                info: {
                    name: 'DELTA 3 Plus+Alternator Charger',
                    desc: '1,024Wh 容量 | 1,500W 出力 (サージ3,000W)\n1,500W AC入力 & 800W走行充電器入力\n10ミリ秒未満のUPS',
                    // discountPrice: 165900,
                    // originalPrice: 237000,
                    // pointRate: 5,
                    productId: '8095171477665',
                    variantId: '44498830721185',
                    showBtnMore: false,
                },
            },
        ],
        data3: [
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    name: 'DELTA 3 Plus+専用エクストラーバッテリー',
                    subtitle: '1,024Wh 容量 | 1,500W 出力 (サージ3,000W)',
                    desc: '1,500W AC入力 & 1,000Wソーラー入力\n10ミリ秒未満のUPS',
                    // discountPrice: 213395,
                    // originalPrice: 328300,
                    // pointRate: 5,
                    productId: '8095181668513',
                    variantId: '44498894323873',
                    showBtnMore: false,
                },
            },
            {
                items: [
                    {
                        img: '',
                    },
                ],
                info: {
                    tag: '公式オンラインストア限定',
                    name: 'DELTA 3 Plus+専用エクストラーバッテリー+220W片面ソーラーパネル',
                    subtitle: '1,024Wh 容量 | 1,500W 出力 (サージ3,000W)',
                    desc: '1,500W AC入力 & 1,000Wソーラー入力\n10ミリ秒未満のUPS',
                    // discountPrice: 213395,
                    // originalPrice: 328300,
                    // pointRate: 5,
                    productId: '8095182717089',
                    variantId: '44498903629985',
                    showBtnMore: false,
                },
            },
        ],
    },
    us: {
        data: [
            {
                name: 'EcoFlow DELTA 3 Plus + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1500W AC Input & 10 ms UPS\n0-100% in 56 min',
                productId: '7289136054345',
                variantId: '41826182496329',
                // moreLink: 'https://us.ecoflow.com/products/delta-3-plus-waterproof-bag?variant=41647163473993',
                subs: [
                    {
                        name: 'EcoFlow 800W Alternator Charger',
                        productId: '7297630797897',
                        variantId: '41654461890633',
                    },
                    // {
                    //     name: 'EcoFlow 400W Solar Panel',
                    //     productId: '7297619001417',
                    //     variantId: '41654447177801',
                    // },
                ],
            },
            {
                name: 'EcoFlow DELTA 3 Plus + 220W Solar Panel + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1000W Solar Input\n0-100% in 5 Hours',
                productId: '7291258830921',
                variantId: '41826188886089',
                // moreLink: 'https://us.ecoflow.com/products/delta-3-plus-220w-portable-solar-panel-delta-3-waterproof-bag?variant=41647176089673',
                subs: [
                    {
                        name: 'EcoFlow 800W Alternator Charger',
                        productId: '7297630797897',
                        variantId: '41654461890633',
                    },
                    // {
                    //     name: 'EcoFlow 400W Solar Panel',
                    //     productId: '7297619001417',
                    //     variantId: '41654447177801',
                    // },
                ],
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1725260645584/d3p_ac_bag.png',
                name: 'EcoFlow DELTA 3 Plus + 800W Alternator Charger + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1500W AC Input & 10ms UPS\n0-100% in 1.3 Hours',
                productId: '7289136054345',
                variantId: '41826183249993',
                // moreLink: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station-800w-alternator-charger-delta-3-bag?variant=41647180546121',
                // subs: [
                //     {
                //         name: 'EcoFlow 400W Solar Panel',
                //         productId: '7297619001417',
                //         variantId: '41654447177801',
                //     },
                // ],
            },
            // {
            //     img: 'https://websiteoss.ecoflow.com/upload/image/1725260629201/de_frv.png',
            //     name: 'EcoFlow DELTA 3',
            //     power: '1024Wh Capacity | 1800W Output',
            //     desc: '1500W AC Input & 500W Solar Input\n10 ms UPS',
            //     productId: '7289136054345',
            //     variantId: '41631710281801',
            //     buyText: 'Coming soon',
            //     callbackBuy: 1,
            //     // moreLink: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station-800w-alternator-charger-delta-3-bag?variant=41647180546121',
            // },
        ],
    },
    ca: {
        data: [
            {
                name: 'EcoFlow DELTA 3 Plus + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1500W AC Input & 10 ms UPS\n0-100% in 56 min',
                productId: '8331157766298',
                variantId: '51645140926835',
                // subs: [
                //     {
                //         name: 'EcoFlow DELTA 2 Smart Extra Battery',
                //         productId: '8338556190874',
                //         variantId: '45175507091610',
                //     },
                //     {
                //         name: 'EcoFlow 220W Solar Panel',
                //         productId: '8338556420250',
                //         variantId: '45175508664474',
                //     },
                // ],
            },
            {
                name: 'EcoFlow DELTA 3 Plus + 160W Solar Panel + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1000W Solar Input\n0-100% in 5 Hours',
                productId: '8338554126490',
                variantId: '51645141221747',
                // subs: [
                //     {
                //         name: 'EcoFlow 800W Alternator Charger',
                //         productId: '8337841389722',
                //         variantId: '45173197865114',
                //     },
                //     {
                //         name: 'EcoFlow DELTA 2 Smart Extra Battery',
                //         productId: '8338556190874',
                //         variantId: '45175507091610',
                //     },
                // ],
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1725421202038/D3P%20(1).png',
                name: 'EcoFlow DELTA 3 Plus + 800W Alternator Charger + Free Bag',
                power: '1024Wh Capacity | 1800W Output',
                desc: '1500W AC Input & 10ms UPS\n0-100% in 1.3 Hours',
                productId: '8331157766298',
                variantId: '51645141025139',
                // subs: [
                //     {
                //         name: 'EcoFlow DELTA 2 Smart Extra Battery',
                //         productId: '8338556190874',
                //         variantId: '45175507091610',
                //     },
                //     {
                //         name: 'EcoFlow 220W Solar Panel',
                //         productId: '8338556420250',
                //         variantId: '45175508664474',
                //     },
                // ],
            },
            // {
            //     img: 'https://websiteoss.ecoflow.com/upload/image/1725260817883/d3_ca.png',
            //     name: 'EcoFlow DELTA 3',
            //     power: '1024Wh Capacity | 1800W Output',
            //     desc: '1500W AC Input & 500W Solar Input\n10 ms UPS',
            //     productId: '8331157766298',
            //     variantId: '45159091142810',
            //     buyText: 'Coming soon',
            //     callbackBuy: 1,
            // },
        ],
    },
    eu: {},
    de: {},
    fr: {},
    it: {},
    es: {},
    au: {
        data: [
            {
                name: 'EcoFlow DELTA 3 Plus',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294452422',
            },
            {
                name: 'EcoFlow DELTA 3 Extra Battery',
                productId: '8435739197638',
                variantId: '44378294485190',
            },
            {
                name: 'EcoFlow DELTA 3 Plus+ D3 EB',
                productId: '8435739197638',
                variantId: '44378294517958',
            },
            {
                name: 'DELTA 3 Plus Solar Generator (Single-facial 220W)',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294550726',
            },
            {
                name: 'DELTA 3 Plus Solar Generator (Bi-facial 220W)',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294583494',
            },
            {
                name: 'DELTA 3 Plus+ 400W SP',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294616262',
            },
            {
                name: 'DELTA 3 Plus+ 400W SP*2',
                power: '1024Wh Capacity | 1800W Output | <10 ms UPS',
                productId: '8435739197638',
                variantId: '44378294649030',
            },
            {
                name: 'DELTA 3 Plus+800W Alternator Charger',
                power: '1024Wh Capacity | 1800W Output',
                productId: '8435739197638',
                variantId: '44378294681798',
            },
        ],
    },
};
